"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var Button_1 = __importDefault(require("@mui/material/Button"));
var react_1 = __importStar(require("react"));
var dotsLoader_1 = __importDefault(require("../Loader/dotsLoader"));
var colors_1 = require("../ThemeProvider/colors");
var styles_1 = require("./styles");
var Loader = function () {
    return (react_1.default.createElement(styles_1.LoaderContainer, null,
        react_1.default.createElement(dotsLoader_1.default, { type: "button" })));
};
var evaluateSx = function (size, buttonType, sx) {
    var customStyles = __assign({}, sx);
    if (size === 'extraLarge') {
        customStyles = __assign(__assign({}, styles_1.extraLargeCss), customStyles);
    }
    else if (size === 'small') {
        customStyles = __assign(__assign({}, styles_1.smallCss), customStyles);
    }
    if (buttonType) {
        customStyles = __assign(__assign({}, styles_1.buttonTypeCss[buttonType]), customStyles);
    }
    return customStyles;
};
var Button = (0, react_1.forwardRef)(function (_a, ref) {
    var loading = _a.loading, children = _a.children, _b = _a.color, color = _b === void 0 ? 'primary' : _b, adminColor = _a.adminColor, size = _a.size, sx = _a.sx, buttonType = _a.buttonType, fab = _a.fab, props = __rest(_a, ["loading", "children", "color", "adminColor", "size", "sx", "buttonType", "fab"]);
    var commonProps = __assign({ disabled: loading, color: adminColor && color === 'primary' ? 'blue' : color, ref: ref, sx: evaluateSx(size, buttonType, sx) }, props);
    var theme = (0, material_1.useTheme)();
    var themeColor = adminColor && color === 'primary'
        ? colors_1.tannerBlue['500']
        : theme.palette.primary.main;
    return fab ? (react_1.default.createElement(styles_1.FabButton, __assign({}, commonProps, { themeColor: themeColor }),
        react_1.default.createElement(styles_1.FabContent, { loading: loading }, children),
        loading && react_1.default.createElement(Loader, null))) : (react_1.default.createElement(Button_1.default, __assign({}, commonProps),
        react_1.default.createElement(styles_1.ButtonContent, { loading: loading }, children),
        loading && react_1.default.createElement(Loader, null)));
});
exports.default = Button;
//# sourceMappingURL=index.js.map